import axios from 'axios';

// Vite injection: VITE_QUIZ_API_URL = https://api.insoweb.ru/quiz (prod)
// или http://localhost:34014 (dev). Без trailing slash.
const QUIZ_API_URL = (import.meta.env.VITE_QUIZ_API_URL || 'http://localhost:34014').replace(/\/$/, '');

export const quizApi = axios.create({
  baseURL: QUIZ_API_URL,
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
});

// Публичные эндпоинты quiz-API не требуют auth — мастер-ключ нужен только
// для CRUD от lk-backend. Здесь никаких заголовков.

export const QUIZ_BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION || 'dev';
